import { RESET_SEARCH, SET_SEARCH } from './actionsTypes';

export const resetSearch = () => {
  return { type: RESET_SEARCH };
};

export const setSearch = payload => {
  return { type: SET_SEARCH, payload };
};
